/// <summary>
/// This object provides js functions for the list of online data <br/>
/// <br/>
/// Author: MKU<br />
/// Date: 22.11.2023<br />
/// Copyright ©: EUDT GmbH 2023 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 22.11.2023                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality for online data                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.FullOnlineList", $.bluaul.vcMenuTemplate, {
    taskRunning: false,
    updateInterval: null,
    countInterval: null,
    myStructure: {
        obj: null,
        online: {
            obj: null,
            ddlInterval: null,
            list: { header: null, entries: null },
            data: null
        },
        allSelectedSignals: null, // holds selected signals
        allSelectedBsaids: null, // holds selected bsaids
        onlineData: null, // holds whole onlinedata (result from getData)
        contentHeight: null,
        timeoutCounter: 0, // holds the already past time
        timeoutThreshold: 0, // holds the threshold for the timeout
        signalsWithNoOnlineData: null
    },

    // widget for online data
    _create: function () {
        var me = this;
        try {
            me.element.html("");
            me.options.invoke.vcvid = 359;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();

        } catch (e) { me.writeError('_create', e); return false; }
        return true;
    },


    _initVariables: function () {
        var me = this;
        try {
            me._super();
            me.settings.defaultChart = "onlinelist";
            me.settings.menu.top.showMenuAsDropdown = false;
            me.settings.menu.top.interval.intervals = 1;
            me.settings.toggleView = true;
            me.settings.showSignalsInContent = false;
            me.settings.signalSelection = true;
            me.settings.showAllSignalsAtStart = false; // necessary, only selected signals are shown
            me.settings.enableFilterForInvalidSignals = true;
            me.settings.hideSignalsWithNotAllowedSettings = false;
            me.settings.showArchiveRules = true;
            me.settings.enableMeta = false;

            me.settings.menu.top.showHeaders = true; 
            me.settings.menu.top.interval.enabled = false; 
            me.settings.menu.top.datatype.enabled = false;
            me.settings.menu.top.charts.enabled = false;
            me.settings.menu.top.opt.enabled = false; 
            me.settings.menu.top.opt.showInterventions = false;
            me.settings.menu.top.opt.showTickets = false;

            me.settings.menu.main.button.enabled = true;
            me.settings.menu.main.button.showTakeBtnOnly = false;
            me.settings.menu.main.date.enabled = false;
            me.settings.menu.main.dateComparison.enabled = false;
            me.settings.menu.main.rampResolution.enabled = false;
            me.settings.menu.main.rampOptions.enabled = false;
            me.settings.menu.main.rampTempCharts.enabled = false;
            me.settings.menu.main.specificOptions.enabled = true;
            me.settings.menu.main.history.enabled = false;

            me.settings.menu.top.opt.showTags = false;
            me.settings.menu.top.opt.showRules = false;
            me.settings.menu.top.export.enabled = true;
            me.settings.menu.top.export.showFavorites = false;
            me.settings.menu.top.export.showShare = false;
            me.settings.selection.choice.enabled = true; // menu "Auswahl" -> left part in selection chart and buttons to select/clean everything
            me.settings.selection.entries.button.enabled = false;
            me.settings.selection.entries.signals.showIcons = false;

            me.settings.subvisual.content.signalSelection = false;

        } catch (e) {
            me.writeError('_initVariables', e);
            return false;
        }
        return true;
    },


    _addAdditionalChartsToSettings: function () {
        var me = this;
        try {

            me._super();

            $.each(me.settings.charts, function () { this.enabled = false });
            me.settings.charts.filter(function (item) { return item.id == "onlinelist" })[0].enabled = true;
            me.settings.charts.filter(function (item) { return item.id == "onlinelist" })[0].multiSelect = "multi";

        } catch (e) {
            me.writeError('_addAdditionalChartsToSettings', e);
            return false;
        }
        return true;
    },


    _loadSubvisualContent: function (contentStatus) {
        /// <summary>
        /// This function loads the chart
        /// </summary>
        var me = this;
        try {

            if (!me.error) {
                
                me._initSubvisualContent(contentStatus);

                me._resetAll();
                objArchExport._enableDisableBtnExport(me, false); // call function from vcMenuTemplate to enable export button

                me._setToggleStatusOptionBox(); // visibility of option box shall be dependent on status of me.status.showContent
                
                me.myStructure.allSelectedBsaids = contentStatus.signals.selectedBsaids;

                me.myStructure.contentHeight = contentStatus.subvisual.content.height;

                // set timeout threshold to mark the signals without online data
                // set to 40, so that after 45s all signals without online data are marked (getData is called every 5s, therefore the highlighting is 5s delayed than set here)
                me.myStructure.timeoutThreshold = 40; 

                // get all selected signals (all signal info) based on selected bsaids
                var lst = [];
                $.each(me.myStructure.allSelectedBsaids, function () {
                    let bsaid = this;
                    let signal = me.signals.filter(function (item) { return item.id == bsaid })[0];
                    lst.push(signal);
                });

                me.myStructure.allSelectedSignals = lst;

                me.vcMenu.subvisual.content.append(me._buildHtml());
                me._generateList(me.myStructure.allSelectedSignals);

                // set heights of different divs
                me._setElementHeights();

                // fill option box -> dropdown list for selection of transmission duration
                me._fillSubvisualStructure();

                // necessary, otherwise events are not called
                me._initSubvisualEvents();

                // call function from vcMenuTemplate to disable export button initially
                objArchExport._enableDisableBtnExport(me, false);
            }

        } catch (e) { me._writeErr(e); }
    },

    _setElementHeights: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {
            //set height of list
            var parentHeight = me.fnd("#div-online").height();
            var headerHeight = me.fnd("#div-online-header").height();
            var listHeight = parentHeight - headerHeight;
            me.fnd(".lst-entries").css("height", listHeight);


        } catch (e) { me._writeErr(e); }
    },

    _buildHtml: function () {
        /// <summary>
        /// This function builds up the html structure
        /// </summary>
        var me = this;
        try {

            let obj = null;
            me.myStructure.online = $("<div>").attr("id", "div-online").addClass("online-list data-container yform").css("height", me.myStructure.contentHeight);
            obj = me.myStructure.online;

            // header of list / columns
            obj.list = $("<div>").attr("id", "div-online-list").addClass("vc-list").css("max-height", me.myStructure.contentHeight);
            obj.header = $("<div>").attr("id", "div-online-header").addClass("vc-list-header color-bg-secondary");
            obj.list.append(obj.header);

            // list with data
            var l = $("<div>").addClass("vc-list-item");
            var c = $("<div>").addClass("vc-list-col");
            l.append(c);
            c.append($("<div>").addClass("vc-list-col-element col0").html(me.specific.resources.signal));
            c.append($("<div>").attr("id", "div-column-val").addClass("vc-list-col-element col1 txtright").html(me.specific.resources.value)); // value itself
            c.append($("<div>").attr("id", "div-column-val").addClass("vc-list-col-element col2 txtright").html("<br>")); // dimension for value
            c.append($("<div>").attr("id", "div-column-zst").addClass("vc-list-col-element col3 txtright").html(me.specific.resources.meterreading));
            c.append($("<div>").addClass("vc-list-col-element col4").html("<br>"));
            c.append($("<div>").attr("id", "div-column-time").addClass("vc-list-col-element col5 txtcenter").html(me.specific.resources.time));
            c.append($("<div>").addClass("vc-list-col-element col6"));
            obj.header.append(l);

            obj.data = $("<div>").addClass("lst-entries vc-list-table ");
            obj.list.append(obj.data);

            obj.append(obj.list);
            
            return obj;

        } catch (e) {
            me.writeError('_buildHtml', e);
            return false;
        }
    },

    _initSubvisualEvents: function () {
        /// <summary>
        /// This function initializes the specific events in the chart
        /// </summary>
        var me = this;
        try {
            me.fnd("#div-btn-send").button().off("click").on("click", function () {
                
                // reset intervals, if they are running
                me._resetAll();
                objArchExport._enableDisableBtnExport(me, false); // call function from vcMenuTemplate to enable export button

                // reset table content
                me.myStructure.onlineData = null;
                me._generateList(me.myStructure.allSelectedSignals);

                var ddlIndex = me.vcMenu.menu.main.specificOptions.find("#specific-option-settings").val();
                me.myStructure.online.ddlInterval = ddlIndex * 60;
                
                // show loading icon before starting the countdown
                let obj = me.vcMenu.menu.main.specificOptions.find("#div-count");
                obj.html(me.getLoadingIcon());

                // insert the send online task
                me.updateData({ typeid: 12, interval: me.myStructure.online.ddlInterval, list: me.myStructure.allSelectedBsaids }, function (result) {
                    if (result) {
                        me.myStructure.timeoutCounter = 0;
                        me.taskRunning = true;

                        if (me.updateInterval != null) {
                            clearInterval(me.updateInterval);
                            clearInterval(me.countInterval);
                        }

                        // start update interval - getData() is called every 5secs
                        me.updateInterval = setInterval(function () { me._getOnlineData();  }, 5000);
                    }
                });
            });

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }

        return true;
    },

    _fillSubvisualStructure: function () {
        /// <summary>
        /// This function fills the option box 
        /// </summary>
        var me = this;
        try {
            let obj = me.vcMenu.menu.main.specificOptions;

            // add send button to send the online task
            var sendMenu = $("<div>").attr("id", "div-send-menu").css("display", "flex").css("width", "100%");
            var divBtnSend = $("<div>").attr("id", "div-btn-send").html(me.specific.resources.send).css({
                "width": "35%",
                "margin-left": "5%"
            });

            var counter = $("<div>").attr("id", "div-count").css({
                "width": "25%",
                "display": "flex",
                "align-items": "center",
                "margin-left": "5%",
                "text-align": "center"
            });

            // add dropdown list with possible values
            var selection = $("<select>").attr("id", "specific-option-settings").addClass("ddl").css("width", "30%");
            selection.append($("<option>").val("1").text("1 min"));
            selection.append($("<option>").val("2").text("2 min"));
            selection.append($("<option>").val("3").text("3 min").attr("selected", "selected")); // set default ddl value
            selection.append($("<option>").val("5").text("5 min"));
            selection.append($("<option>").val("10").text("10 min"));

            sendMenu.append(selection, divBtnSend, counter);

            // add the option box
            obj.vcOptionBox({
                caption: me.resources.selection, items: [{ button: me.specific.resources.transmissionDuration, clickable: true, isList: true, content: sendMenu }]
            });

            // set height of right wrapper (wrapper of option box) to specific value, otherwise content is moving by toggling the visibility of the option box
            var hWrapper = me.vcMenu.menu.main.wrapper.height();
            me.vcMenu.menu.main.rightWrapper.css("height", hWrapper);


        } catch (e) { me._writeErr(e); }
    },

    _getOnlineData: function () {
        /// <summary>
        /// This function gets the online data
        /// </summary>
        var me = this;
        try {

            me.getData({ typeid: 12, list: me.myStructure.allSelectedBsaids, signalList: me.myStructure.allSelectedSignals }, function (result) {
                
                if (result != null && me.taskRunning) {
                    let obj = me.vcMenu.menu.main.specificOptions.find("#div-count");
                    
                    // start interval for counter, if not running yet
                    if (obj.val() == "") {
                        me._startCounter();
                        objArchExport._enableDisableBtnExport(me, true); // call function from vcMenuTemplate to enable export button 
                    }

                    me.myStructure.onlineData = result;
                    me._generateList(me.myStructure.allSelectedSignals);
                }
                else {
                    // if no online data is received and timeout threshold is reached, list is generated again with "N/A" as value
                    if (me.myStructure.timeoutCounter > me.myStructure.timeoutThreshold) {
                        me._generateList(me.myStructure.allSelectedSignals);
                    }
                }
            });

            // increase timeout counter in each getData interval
            me.myStructure.timeoutCounter += 5;
            
            // if no data is coming in within selected interval, update is stopped
            if (me.myStructure.timeoutCounter > me.myStructure.online.ddlInterval && me.myStructure.onlineData === null) {
                me.vcMenu.menu.main.specificOptions.find("#div-count").html("");
                clearInterval(me.updateInterval);
                clearInterval(me.countInterval);
                me.taskRunning = false;
            }

        } catch (e) { me.writeError('_getOnlineData', e); return false; } return true;
    },

    _startCounter: function () {
        /// <summary>
        /// This function starts the counter, which is visualized and the interval for the counter decrease
        /// </summary>
        var me = this;
        try {

            let obj = me.vcMenu.menu.main.specificOptions.find("#div-count");
            
            obj.val(me.myStructure.online.ddlInterval);
            obj.html("");
            obj.html(obj.val() + " sec");
            me.countInterval = setInterval(function () { me._decreaseCounter() }, 1000); // start interval for decreasing of counter

        } catch (e) { me.writeError('_startCounter', e); return false; } return true;
    },

    _decreaseCounter: function () {
        /// <summary>
        /// This function decreases the counter by a second
        /// </summary>
        var me = this;
        try {
            let obj = me.vcMenu.menu.main.specificOptions.find("#div-count");
            var newVal = obj.val() - 1;
            obj.val(newVal);
            obj.html(obj.val() + " sec");

            // if counter is finished, intervals are resetted
            if (obj.val() == 0) { me._resetAll(); }

        } catch (e) { me.writeError('_decreaseCounter', e); return false; } return true;
    },

    _generateList: function (signals) {
        /// <summary>
        /// This function generates the list, which is shown in the table
        /// </summary>
        var me = this;
        try {
            var list = me.fnd(".lst-entries");
            list.html("");
            
            if (signals === null) {
                list.html($("<br>"));
                list.append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                return false;
            }

            // get all signals with no online data currently available
            me._getSignalsWithNoOnlineData();

            // fill corresponding list with items
            for (var i = 0; i < signals.length; i++) {
                list.append(me._fillItems(i, signals));
            }

            me._formatTable();

        } catch (e) { me.writeError('_generateList', e); return false; } return true;
    },

    _fillItems: function (i, signals) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            var item = $("<div>", { "class": "vc-list-item" }); 

            item.append($("<div>", { "class": "vc-list-col col0" }).html($("<div>", { "class": "vc-list-col-element " + me._hasNoOnlineData(signals[i].id), "html": signals[i].name + " [" + signals[i].dims + "]" })));
            item.append($("<div>", { "class": "vc-list-col col1" }).html($("<div>", { "class": "vc-list-col-element value " + me._hasNoOnlineData(signals[i].id), "html": me._fillOnlineData(signals[i], "val") })));
            item.append($("<div>", { "class": "vc-list-col col2" }).html($("<div>", { "class": "vc-list-col-element txtLeft " + me._hasNoOnlineData(signals[i].id), "html": me._fillOnlineData(signals[i], "dims") })));            
            item.append($("<div>", { "class": "vc-list-col col3" }).html($("<div>", { "class": "vc-list-col-element " + me._hasNoOnlineData(signals[i].id) + me._isVirtualSignal(signals[i]), "html": me._fillOnlineData(signals[i], "zst") })));
            item.append($("<div>", { "class": "vc-list-col col4" }).html($("<div>", { "class": "vc-list-col-element ", "html": "<br>" })));
            item.append($("<div>", { "class": "vc-list-col col5" }).html($("<div>", { "class": "vc-list-col-element time " + me._hasNoOnlineData(signals[i].id), "html": me._fillOnlineData(signals[i], "timestamp") })));
            item.append($("<div>", { "class": "vc-list-col col6" }).html($("<div>", { "class": "vc-list-col-element txtLeft", "html": me._animateUpdate(signals[i].id) })).fadeIn(1000).fadeOut(2000)); 

            return item;

        } catch (e) { me.writeError('_fillItems', e); return false; }
    },

    _animateUpdate: function (bsaid) {
        /// <summary>
        /// This function animates the blinking of the red point for updated signals
        /// </summary>
        var me = this;
        try {
            var htmlString = "";
            if (me.myStructure.onlineData != null && me.myStructure.onlineData.rows != null) {
                for (var i = 0; i < me.myStructure.onlineData.rows.length; i++) {

                    if (me.myStructure.onlineData.rows[i].bsaid == bsaid) {
                        if (me.myStructure.onlineData.rows[i].change == 1)
                            htmlString = "<i class='fa-solid fa-circle icon-color-error update-marker'></i>";
                    } 
                }
            }

            return htmlString;

        } catch (e) { me.writeError('_animateUpdate', e); return false; }
    },

    _hasNoOnlineData: function (bsaid) {
        /// <summary>
        /// This function checks if signal has online data, if not, then opacity 0.4 is added (disabled look)
        /// </summary>
        var me = this;
        try {
            var addClass = "opcActive";

            // if timeout threshold is reached, signal is marked additionally with N/A
            if (me.myStructure.timeoutCounter > me.myStructure.timeoutThreshold)
                addClass = "errActive";

            if (me.myStructure.onlineData != null && me.myStructure.onlineData.rows != null) {
                for (var i = 0; i < me.myStructure.onlineData.rows.length; i++) {
                    if (me.myStructure.onlineData.rows[i].bsaid == bsaid)
                        addClass = "";
                }
            }

            return addClass;

        } catch (e) { me.writeError('_hasNoOnlineData', e); return false; }
    },

    _isVirtualSignal: function (virtualSignal) {
        /// <summary>
        /// This function checks if signal is a virtual signal; if no, string (zst) is formatted as value, otherwise not
        /// </summary>
        var me = this;
        try {
            var addClass;

            if (!virtualSignal.issignalrule) // if no virtual signal
                addClass = " value";
            else // if virtual signal
            {
                // if timeout threshold is reached, check if online data is null -> then different class is necessary to visualize the N/A correctly
                if (me.myStructure.timeoutCounter > me.myStructure.timeoutThreshold) {

                    if ((me.myStructure.signalsWithNoOnlineData != null && me.myStructure.signalsWithNoOnlineData.includes(virtualSignal.id)) || me.myStructure.onlineData == null)
                        addClass = " value";
                    else
                        addClass = " placeholder";

                }
                else
                    addClass = " placeholder";
            }

            return addClass;
                
        } catch (e) { me.writeError('_isVirtualSignal', e); return false; }
    },

    _fillOnlineData: function (signal, key) {
        /// <summary>
        /// This function gets the online values for a given bsaid to fill the list with the online data
        /// </summary>
        var me = this;
        try {            

            // received online data is not empty and is loaded to the table
            if (me.myStructure.onlineData != null && me.myStructure.onlineData.rows != null) {
                for (var i = 0; i < me.myStructure.onlineData.rows.length; i++) {

                    if (me.myStructure.onlineData.rows[i].bsaid == signal.id) {
                        var str;
                        switch (key) {
                            case "val":
                                return me._checkEntryString(me.myStructure.onlineData.rows[i].val);
                            case "zst":
                                str = me._checkEntryString(me.myStructure.onlineData.rows[i].zst);

                                // if virtual signal, only placeholder is shown instead of zst
                                if (signal.issignalrule)
                                    str = "-";

                                return str;

                            case "timestamp":                              
                                me.myStructure.onlineData.rows[i].timestamp = window.moment(me.myStructure.onlineData.rows[i].timestamp).format('HH:mm:ss');
                                str = me._checkEntryString(me.myStructure.onlineData.rows[i].timestamp);

                                // if virtual signal, only placeholder is shown instead of timestamp
                                if (signal.issignalrule)
                                    str = "-";

                                return str;
                            case "dims":
                                return me._checkEntryString(signal.dims);
                            default:
                                break;
                        }
                    }
                }

                // if timeout threshold is reached, signals without online data are marked with N/A
                if (me.myStructure.timeoutCounter > me.myStructure.timeoutThreshold) {
                    if (me.myStructure.signalsWithNoOnlineData.includes(signal.id)) {
                        return me._highlightSignalsWithNoOnlineData(key);
                    }
                }
            }
            else { // no online data is reached yet
                // if timeout threshold is reached, all signals are marked with N/A
                if (me.myStructure.timeoutCounter > me.myStructure.timeoutThreshold) {
                    return me._highlightSignalsWithNoOnlineData(key);
                }
            }

            return "";

        } catch (e) { me.writeError('_fillOnlineData', e); return false; }
    },

    _highlightSignalsWithNoOnlineData: function (key) {
        /// <summary>
        /// This function gets the correct return string for each signal with no online data
        /// </summary>
        var me = this;
        try {
            switch (key) {
                case "val":
                    return "N ";
                case "dims":
                    return "/ A";
                case "zst":
                    return "N / A";
                case "timestamp":
                    return "N / A";
                default:
                    break;
            }

            return "";

        } catch (e) { me.writeError('_highlightSignalsWithNoOnlineData', e); return false; }
    },

    _getSignalsWithNoOnlineData: function () {
        /// <summary>
        /// This function gets all signals without current online data (these signals are marked in the table after timeout threshold is reached)
        /// </summary>
        var me = this;
        try {
         
            if (me.myStructure.onlineData != null && me.myStructure.onlineData.rows != null) {
                var lstOnline = [];
                var lstSelected = [];

                // fill array with all signal bsaids with valid online data
                for (var i = 0; i < me.myStructure.onlineData.rows.length; i++) {
                    lstOnline.push(me.myStructure.onlineData.rows[i].bsaid);                    
                }

                // fill array with all signal bsaids, which are selected by the user
                for (var j = 0; j < me.myStructure.allSelectedSignals.length; j++) {
                    lstSelected.push(me.myStructure.allSelectedSignals[j].id);
                }

                // get the selected signals where no online data is currently available (to mark them in the table)
                var difference = $(lstSelected).not(lstOnline).get();
                me.myStructure.signalsWithNoOnlineData = difference;
                
            }

        } catch (e) { me.writeError('_getSignalsWithNoOnlineData', e); }
    },

    _checkEntryString: function (str) {
        /// <summary>
        /// This function checks, if a string is empty and if so, a placeholder is added (otherwise values are sometimes shifted)
        /// </summary>
        var me = this;
        try {
            if (str == "" || str == null)
                return "-";
            else
                return str;

        } catch (e) { me.writeError('_checkEntryString', e); return false; }
    },

    _resetAll: function () {
        /// <summary>
        /// This function resets all intervals, objects, ... which need to be resetted for a new send task
        /// </summary>
        var me = this;
        try {
            me.taskRunning = false;
            let obj = me.vcMenu.menu.main.specificOptions.find("#div-count");
            if (me.updateInterval != null) {
                clearInterval(me.countInterval);
                clearInterval(me.updateInterval);
            }

            obj.val("");
            obj.html("");
            me.myStructure.onlineData = null;
            me.myStructure.timeoutCounter = 0;
        } catch (e) { me.writeError('_resetAll', e); }
    },

    _formatTable: function () {
        /// <summary>
        /// This function formats the table
        /// </summary>
        var me = this;
        try {

            me.fnd('.lst-entries .vc-list-item:even').addClass('alt');
            me.fnd('.lst-entries .vc-list-item .vc-list-col-element.value').formatDouble(2);

        } catch (e) { me.writeError('_formatTable', e); }
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-online").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }

});

